import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { userInfo } from '../../../store/selectors/user';
import { orderAPI } from '../api/orderAPI';

export const activeOrdersCountQueryKey = ['active-orders-count'] as const;

export const useGetActiveOrdersCount = () => {
  const { isAuth } = useSelector(userInfo);

  const { data } = useQuery({
    queryKey: activeOrdersCountQueryKey,
    queryFn: async () => await orderAPI.getActiveOrdersCount(),
    select: response =>
      response.data.success && response.data.count > 0
        ? response.data.count
        : 0,
    enabled: isAuth,
    refetchOnMount: 'always',
    refetchOnWindowFocus: 'always',
  });

  return isAuth ? (data ?? 0) : 0;
};
